'use client';
import { CollectionHeader as Shared } from '@launchstore/shared-puck';
export const CollectionHeader: any = Shared;
export default CollectionHeader;
